"use client";

import { usePathname } from "next/navigation";
import type { FC } from "react";

import { WalletButton } from "../molecules/WalletButton";

const getTitle = (pathname: string | null) => {
  if (pathname === "/liquidity/") {
    return "Liquidity";
  }
  if (pathname?.includes("/mnde/")) {
    return "MNDE";
  }

  return "";
};

interface MobileHeaderProps {
  className?: string;
}

export const MobileHeader: FC<MobileHeaderProps> = ({ className }) => {
  const pathname = usePathname();
  const isValidatorsDetailsPath = pathname?.includes("validators/details");
  const isValidatorsPath = pathname?.includes("validators");

  return (
    <div
      className={`px-3 py-3 flex flex-row-reverse justify-between items-center z-48 ${className} ${
        isValidatorsDetailsPath || isValidatorsPath ? "hidden" : ""
      }`}
    >
      <div className="flex gap-1 items-center">
        <WalletButton variant="header" />
      </div>
      <div className="font-medium text-2xl">{getTitle(pathname)}</div>
    </div>
  );
};
